// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".folder_drop_loading-module__loader--FG6LE{padding:16px}@media screen and (max-width: 48em){.folder_drop_loading-module__loader--FG6LE{height:247px}}\n", ""]);
// Exports
exports.locals = {
	"loader": "folder_drop_loading-module__loader--FG6LE"
};
module.exports = exports;
